import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import TopNav from "@/components/layout/TopNav";

export default function AppShell() {
    return (
        <div className="min-h-screen flex bg-background">
            <div className="hidden md:flex md:w-64 lg:w-72 flex-shrink-0 sticky top-0 h-screen">
                <Sidebar />
            </div>
            <div className="flex-1 min-w-0 flex flex-col">
                <TopNav />
                <main className="flex-1 px-4 md:px-8 py-6 md:py-8 max-w-[1400px] w-full mx-auto">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
